import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import LinearFlowHeading from '../../widgets/LinearFlowHeading';
import AddPersonRoleSearch from './AddPersonRoleSearch';
import AddBursaryApplicationDetails from './AddBursaryApplicationDetails';
import AddBursaryApplicationTypeSelect from './AddBursaryApplicationTypeSelect';
import AddBursaryApplication from './AddBursaryApplication';
import AddBursaryApplicationDocuments from './AddBursaryApplicationDocuments';
import "../../Grid.css";
import "../../Form.css";
import "../../App.css";
import ViewUtils from '../../ViewUtils';
import { ViewContainer } from "../../View.jsx";
import withMenuPermission from "../../widgets/withMenuPermission";
import LoadingIndicator from '../../LoadingIndicator';

const steps = [
    { name: "Identity Details", tooltip: "Search the system for an existing employed bursary. If one does not exist, click proceed to apply for a new employed bursary" },
    { name: "Applicant Details", tooltip: "Capture applicant details" },
    { name: "Application Type", tooltip: "Capture application type" },
    { name: "Bursary Application", tooltip: "Capture Bursary Application" },
    { name: "Documents", tooltip: "Upload the required documents to be able to submit your application" }
];

const utils = new ViewUtils();
class AddBursaryApplicationFlow extends Component {
    state = {
        currentStepIndex: 0,
        data: null,
        documents: {},
        saveMessage: "",
        key: Math.floor(100000000 + Math.random() * 900000000),
        hasSaveError: false,
        IsExternal: utils.isNull(this.props.IsExternal) ? false : this.props.IsExternal,
        selectedApplicationSocioEconomicStatus: this.props.location.state.selectedApplicationSocioEconomicStatus

    }

    navigate(index, forward) {
        if (forward) {
            if (index !== 4) {
                this.setState({ currentStepIndex: index + 1 });
            }
        } else {
            this.setState({ currentStepIndex: index - 1 });
        }
    }

    stepHandler(index, forward, data) {
        if (index === 0) {
            if (!utils.isNull(this.state.data) && !utils.isNull(this.state.data.personRoleDetails) && !forward) {
                this.setState({
                    data: {  ...this.state.data, personRoleDetails: { ...this.state.data.personRoleDetails, Person: data.PersonDetails }
                    }
                }, () => { this.navigate(index, forward) });
            } else {
                this.setState({ data: data }, () => { this.navigate(index, forward) });
            }
        } else if (index === 1) {
            if (!utils.isNull(data)) {
                this.setState({
                    data: { ...this.state.data, personRoleDetails: data }
                }, () => { this.navigate(index, forward) });
            } else if (!forward) {
                this.navigate(index, forward);
            }
        } else if (index === 2) {
            if (!utils.isNull(data)) {
                this.setState({
                    data: { ...this.state.data, bursaryApplicationType: data }
                }, () => { this.navigate(index, forward) });
            } else if (!forward) {
                this.navigate(index, forward);
            }
        }
        else if (index === 3) {
            if (!utils.isNull(data)) {
                this.setState({
                    data: { ...this.state.data, bursaryApplication: data }
                }, () => { this.navigate(index, forward) });
            } else if (!forward) {
                this.navigate(index, forward);
            }
        }
        else if (index === 4) {
            if (!utils.isNull(data) && forward) {
                let bursaryAppEmployedData = {};
                bursaryAppEmployedData.person = this.state.data.personRoleDetails;
                bursaryAppEmployedData.applicationType = this.state.data.bursaryApplicationType;
                bursaryAppEmployedData.application = this.state.data.bursaryApplication;
                bursaryAppEmployedData.documents = data;
                bursaryAppEmployedData.GUID = this.state.key;
                bursaryAppEmployedData.BursaryAppSocioEcoStatus = this.state.selectedApplicationSocioEconomicStatus;

                utils.invokeUrlExternal("api/sims/BursaryApplication/AddBursaryApplication", (data) => {
                    this.props.history.push({
                        pathname: '/bursaryApplicationSocioEcoSelect'
                    })
                }, () => { alert(utils.SYSTEM_ERROR_MESSAGE) }, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        "Authorization": "Bearer " + localStorage.getItem("token")
                    },
                    body: JSON.stringify(bursaryAppEmployedData)
                });

            } else {
                this.setState({
                    data: { ...this.state.data, documents: data }
                }, () => { this.navigate(index, forward) });
            }
        }
    }

    handleToolbarButtonClick(buttonId) {
    }

    componentDidMount() {
        utils.setLegend("Add Bursary Application");
    }

    render() {
        return (
            <ViewContainer topPadding="0">
              {this.state.IsExternal ? <LoadingIndicator /> : null}
                <Row>
                    <Col>
                        <Row style={{ marginBottom: "20px" }}>
                            <Col> <LinearFlowHeading steps={steps} currentIndex={this.state.currentStepIndex} /></Col>
                        </Row>
                        {this.state.currentStepIndex === 0 ?

                            <AddPersonRoleSearch role="BursaryApplication" applicationType={this.state.selectedApplicationSocioEconomicStatus}
                                data={this.state.data} IsExternal={this.props.IsExternal}
                                alreadyExistErrorMessage="An application with the specified criteria already exist"
                                stepHandler={(index, forward, data) => this.stepHandler(index, forward, data)} />
                            : null}
                        {this.state.currentStepIndex === 1 ? <AddBursaryApplicationDetails socioEconomicStatus={this.state.selectedApplicationSocioEconomicStatus} IsExternal={this.props.IsExternal} data={this.state.data} stepHandler={(index, forward, data) => this.stepHandler(index, forward, data)} /> : ""}
                        {this.state.currentStepIndex === 2 ? <AddBursaryApplicationTypeSelect socioEconomicStatus={this.state.selectedApplicationSocioEconomicStatus} data={this.state.data} IsExternal={this.props.IsExternal} stepHandler={(index, forward, data) => this.stepHandler(index, forward, data)} /> : ""}
                        {this.state.currentStepIndex === 3 ? <AddBursaryApplication socioEconomicStatus={this.state.selectedApplicationSocioEconomicStatus} data={this.state.data} IsExternal={this.props.IsExternal} stepHandler={(index, forward, data) => this.stepHandler(index, forward, data)} /> : ""}
                        {this.state.currentStepIndex === 4 ? <AddBursaryApplicationDocuments data={this.state.data} ukey={this.state.key} IsExternal={this.props.IsExternal} stepHandler={(index, forward, data) => this.stepHandler(index, forward, data)} /> : ""}
                    </Col>
                </Row>
            </ViewContainer>
        );
    }
}

export default withRouter(withMenuPermission(AddBursaryApplicationFlow));
